import { InterventionCard } from '../components/InterventionCard';
import { SectionWrapper } from '../components/SectionWrapper';
import { StatStripCell } from '../components/StatStripCell';

import styles from './TwoInterventionsSection.module.css';

export function TwoInterventionsSection() {
  return (
    <SectionWrapper background="soft" data-testid="research-section-interventions">
      <div className={styles.section}>
        <div className={styles.header}>
          <p className={styles.eyebrow}>WHAT WAS TESTED</p>
          <h2 className={styles.title}>
            Two interventions, deployed together in one course.
          </h2>
          <p className={styles.subhead}>
            Both interventions are grounded in Situated Expectancy-Value Theory
            of Achievement Motivation - students engage more in tasks they
            expect to succeed in and perceive as valuable.
          </p>
        </div>

        <div className={styles.cards}>
          <InterventionCard
            eyebrow="Intervention 01"
            paragraphs={[
              'Optional supplemental math assignments were offered to all students. Extra credit was scaled so that students with lower exam scores could earn more from completing the assignments - making the effort proportionally more valuable to the students who most needed the boost.',
              'This addresses the "gifts for the gifted" problem common to traditional extra credit, where high-performing students receive marginal benefit and lower-performing students receive a structural reward for catching up.',
            ]}
            stat="54% vs. 19%"
            statCaption="Completion rates among students below the class FCI mean - with scaled incentives vs. without."
            title="Scaled extra credit on supplemental math."
          />
          <InterventionCard
            eyebrow="Intervention 02"
            paragraphs={[
              'Optional AI-generated hints were embedded directly in physics homework problems on Kudu. Hints were grounded in the chapter content the student was studying - so a student stuck on a problem could ask for guidance without leaving the course context, and without the social cost of asking a TA or peer.',
              'The hints are explicitly designed not to provide solutions. They guide students through the reasoning rather than handing them an answer.',
            ]}
            stat="88%"
            statCaption="Of students used AI-generated hints on at least one homework problem matched to an exam question."
            title="AI-generated hints in homework."
          />
        </div>

        <div className={styles.statStrip}>
          <StatStripCell label="More on AI hint usage" />
          <StatStripCell
            caption="Used hints on at least one matched problem"
            value="88%"
          />
          <StatStripCell caption="Used hints on at least five problems" value="57%" />
          <StatStripCell
            caption="Average share of questions where hints were used"
            value="~20%"
          />
        </div>
      </div>
    </SectionWrapper>
  );
}
